import { isMobileScreen, setPageTitle } from "../common";
import ShopNavigationPanel from "./extra/ShopNavigationPanel";

function ShippingPolicy() {
  setPageTitle("Shipping Policy | Fast & Secure Delivery Information");
  return (
    <>
      <section
        className="breadcrumbs-custom"
        data-preset='{"title":"Breadcrumbs","category":"header","reload":false,"id":"breadcrumbs"}'
      >
        <div className="breadcrumbs-custom-container">
          <ul className="breadcrumbs-custom-path">
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <span className="">Shipping Policy</span>
            </li>
          </ul>
        </div>
      </section>
      <section
        className={isMobileScreen() ? "bg-white" : "section-sm bg-white"}
      >
        <div className="container-xl">
          <div className="row row-40">
            {isMobileScreen() ? (
              <></>
            ) : (
              <div className="col-md-2">
                <ShopNavigationPanel />
              </div>
            )}
            <div className="col-md-10">
              <div className="container">
                <h1 className="h3 font-weight-bold mt-2">Shipping Policy</h1>
                <div className="body-1">
                  This Shipping Policy applies to all orders placed within the
                  United States. By purchasing from our store, you agree to the
                  terms outlined below.
                </div>

                <section className="mb-4 mt-4">
                  <h2 className="h4 section-title mb-2">
                    Free Shipping & Rates
                  </h2>
                  <div className="body-1 mb-2">
                    <div>
                      We offer <strong>FREE SHIPPING</strong> on all orders over
                      $50.
                    </div>
                    <div>
                      Orders under $50 will incur standard shipping charges,
                      calculated at checkout.
                    </div>
                    <div>
                      All shipping charges are <strong>non-refundable</strong>.
                    </div>
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">Order Processing</h2>
                  <div className="body-1 mb-2">
                    <div>Orders are processed Monday–Friday.</div>
                    <div>
                      Orders placed after 2:00 PM EST Friday will be processed
                      the following Monday.
                    </div>
                    <div>
                      We do not process or ship orders on Sundays or national
                      holidays.
                    </div>
                    <div>
                      Processing time is typically 24–72 hours, regardless of
                      the shipping method selected.
                    </div>
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">
                    Delivery & Transit Times
                  </h2>
                  <div className="body-1 mb-2">
                    <div>Domestic orders are shipped via USPS.</div>
                    <div>
                      Transit times are based on business days (Monday–Friday).
                    </div>
                    <div>
                      You will receive a tracking number once your order is
                      shipped.
                    </div>
                    <div
                      className="body-2 text-warning"
                      style={{ fontSize: 14 }}
                    >
                      Please note: Delivery times are estimates and cannot be
                      guaranteed. Carriers may experience delays beyond our
                      control.
                    </div>
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">
                    Shipping Restrictions
                  </h2>
                  <div className="body-1 mb-2">
                    <div>
                      We currently do not ship to the following states:{" "}
                      <strong>
                        Alabama, Alaska, Colorado, North Dakota, Oregon, and
                        Hawaii
                      </strong>
                      .
                    </div>
                    <div>
                      We also cannot ship to certain restricted counties and
                      municipalities. Please check your local regulations before
                      ordering.
                    </div>
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">Address Accuracy</h2>
                  <div className="body-1">
                    Please ensure your shipping address is entered correctly.
                    Incomplete or inaccurate addresses may result in delays,
                    returns, or lost packages. We are not responsible for costs
                    associated with incorrect address submissions.
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">
                    Lost, Delayed, or Undelivered Packages
                  </h2>
                  <div className="body-1 mb-2">
                    <div>
                      Once an order leaves our facility, responsibility for
                      delivery rests with the carrier.
                    </div>
                    <div>
                      If tracking shows no updates or indicates issues, please
                      contact the carrier first for resolution.
                    </div>
                    <div>
                      Lost or undelivered packages must be reported to the
                      carrier. We will assist in resolving issues, but we cannot
                      guarantee compensation for carrier errors.
                    </div>
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">
                    Damaged or Incorrect Orders
                  </h2>
                  <div className="body-1 mb-2">
                    <div>
                      If your order arrives damaged, missing items, or
                      incorrect, you must contact us within{" "}
                      <strong>48 hours of delivery</strong>.
                    </div>
                    <div>
                      If a parcel is visibly damaged in transit, please refuse
                      the package and notify our customer support immediately.
                    </div>
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">
                    Canceling or Altering Orders
                  </h2>
                  <div className="body-1 mb-2">
                    <div>
                      Due to the speed of our processing, once an order is
                      placed and in progress, we cannot alter, cancel, or change
                      it.
                    </div>
                    <div>
                      If you wish to cancel an order, please contact us
                      immediately. Orders already shipped cannot be canceled.
                    </div>
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">
                    Delivery to Freight Forwarders
                  </h2>
                  <div className="body-1">
                    If you choose to ship your order to a mail or freight
                    forwarding service, our responsibility ends once the package
                    is delivered to the forwarding address. We are not liable
                    for damages, loss, customs seizure, or missing items after
                    initial delivery.
                  </div>
                </section>

                <footer className="mt-5">
                  <div className="font-weight-bold small">
                    *This is an auto-generated policy. Please contact support
                    for any questions.
                  </div>
                </footer>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ShippingPolicy;
